import {BaseModel} from "../base";

class EventGroupModel extends BaseModel {

    name() {
        return this._data.name;
    }

    colour() {
        return this._data.colour;
    }
}

export {
    EventGroupModel
}